<template>
<div class="asset__list">
    <ul>
        <li @click="$emit('add')">
        <div class="asset__list__item" title="Add Video Asset" style="background-color:#d1d1d1">
          <div class="asset__list__item__add">
            <i class="material-icons icon">add</i>
          </div>
        </div>
      </li>
      <li class="asset__list__item" :class="item.id === selectedAsset.id ? 'selected-asset' : ''" v-for="item in items" v-bind:key="item.id"  @click.stop="editItem(item)" :style="'background:url(' +  item.thumbnailUrl + ') no-repeat center center'">
         <div class="asset__list__item__edit" v-tooltip.bottom-center="'add interactions'">
            <i class="material-icons icon">edit</i>
          </div>

        <div class="title" :class="item.id === selectedAsset.id ? 'selected-title' : ''"><span>{{item.title !== undefined ? item.title.substring(0, 25) : ''}}</span></div>
        <div class="asset__list__item__buttom">
          <button class="asset__list__item__buttom btn-edit" v-tooltip.bottom-center="'edit properties'" @click.stop="editSettings(item)"><i class="material-icons">settings</i></button>
          <button class="asset__list__item__buttom btn-more" v-tooltip.bottom-center="'more actions'" @click.stop="openActions(item)"><i class="material-icons">more_vert</i></button>
          <div class="asset__list__item__buttom__actions" v-if="item.actions">
            <button class="button" title="Clone" @click.stop="openCloneMenu(item)"><i class="material-icons">file_copy</i></button>
            <button class="button" title="Preview" @click.stop="previewItem(item)"><i class="material-icons">video_label</i></button>
            <button class="button" title="Translate" @click.stop="translateItem(item)"><i class="material-icons">language</i></button>
            <button class="button" title="Export" @click.stop="exportItem(item)"><i class="material-icons">file_download</i></button>
            <button class="button" title="Delete" @click.stop="asset=item,showConfirm()"><i class="material-icons">delete</i></button>
          </div>
          <div class="asset__list__item__buttom__actions__clone" v-if="item.clone">
            <div><i v-on:click.stop title="Close" @click="item.clone=false" class="close material-icons">close</i></div>
            <span>{{item.title !== undefined ? item.title.substring(0, 20) : ''}}</span>
            <div class="dropdown">
              <label>Project:</label>
              <select v-on:click.stop v-model="item.cloneProjectId">
                <option v-for="project in projects" v-bind:key="project.id" :value="project.id">{{project.title}}</option>
              </select>
            </div>
            <button title="Clone asset" v-on:click.stop="cloneItem(item)" class="asset__btn">Clone</button>
          </div>
        </div>
      </li>
    
    </ul>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Edit from './edit'

export default {
  name: 'list',
  props: ['items'],
  data: () => ({
    asset: null
  }),
  computed: {
    ...mapGetters(['selectedAsset', 'video', 'projects', 'selectedProject'])
  },
  components: { Edit },
  created: function() {
    document.addEventListener('click', this.closeActions);
  },
  beforeDestroy: function() {
    document.removeEventListener('click', this.closeActions);
  },
  methods: {
    ...mapActions(['loadData', 'setAsset', 'deleteAsset', 'createAsset']),
    ...mapMutations(['setMode']),
    exportItem(item) {
      this.selectItem(item)
      this.$router.push('export')
    },
    showConfirm() {
      const options = {title: `Delete asset ${this.asset.title}`, cancelLabel: 'No'}
      this.closeActions()
      this.$dialogs.confirm('Do you want to delete this asset?', options)
      .then(res => {
        if (res.ok) {
          this.deleteAsset(this.asset)
        }
      })
    },
    editItem(item) {
      this.selectItem(item)
      this.setMode(null)
      this.$router.push('editor')
    },
    previewItem(item) {
      this.selectItem(item)
      this.$router.push('show')
    },
    translateItem(item) {
      this.selectItem(item)
      this.$router.push('translate')
    },
    openCloneMenu(item) {
      this.items.map(asset => {
        if (asset.id === item.id && !asset.clone) {
          asset.clone = true
          asset.cloneProjectId = item.projectId
        } else {
          asset.clone = false
        }
      })
    },
    openActions(item) {
      this.items.map(asset => {
        if (item.id === asset.id && !asset.actions) {
          asset.actions = true;
        } else {
          asset.actions = false;
          asset.clone = false;
        }
      })
    },
    closeActions: function () {
      this.items.map(item => {
        item.actions = false;
        item.clone = false;
      })
    },
    cloneItem(item) {
      const that = this
      const cloneItemString = JSON.stringify(item)
      const cloneItem = JSON.parse(cloneItemString)
      cloneItem.title = item.title + '_clone'
      cloneItem.projectId = item.cloneProjectId
      this.createAsset(cloneItem).then(() => {
          let video = JSON.parse(that.selectedAsset.content)
          video.assetId = that.selectedAsset.id
          that.loadData(video)
      });

      this.items.map(item => {
        item.clone = false
        item.actions = false
      })
    },
    selectItem(item) {
      const video = item.id === this.video.assetId ? this.video : JSON.parse(item.content)
      video.assetId = item.id
      video.assetTitle = item.title
      this.url = video.src
      item.content = JSON.stringify(video)
      this.loadData(video)
      this.setAsset(item)
    },
    editSettings(item) {
      item.visible = true
      this.$emit("openMetaForm", item)
      this.selectItem(item)
    },
    formateDate(item) {
      return new Date(item.updatedDate !== undefined ? item.updatedDate : item.createdDate).toLocaleString('de-CH')
    }
  }
}
</script>
